import { defineSlotRecipe } from "@chakra-ui/react";

const libThemeBase = {
    requiredIndicator: {
        color: "fg.error",
        lineHeight: "1"
    },
    root: {
        display: "flex",
        width: "100%",
        position: "relative",
        gap: "1.5"
    },
    label: {
        display: "flex",
        alignItems: "center",
        textAlign: "start",
        textStyle: "sm",
        fontWeight: "medium",
        gap: "1",
        color: "base.600",
        textTransform: "capitalize",
        userSelect: "none",
        _disabled: {
            opacity: "0.5"
        }
    },
    errorText: {
        display: "inline-flex",
        alignItems: "center",
        fontWeight: "medium",
        gap: "1",
        color: "fg.error",
        textStyle: "xs"
    },
    helperText: {
        color: "fg.muted",
        textStyle: "xs"
    }
};

// TODO: unify legacy, fill in `base`, update with Bark.
const fieldRecipe = defineSlotRecipe({
    className: "chakra-field",
    slots: [
        "root",
        "container",
        "label",
        "requiredIndicator",
        "errorIcon",
        "errorText",
        "helperText"
    ],
    base: {},
    variants: {
        variant: {
            legacy: {
                label: {
                    fontSize: { base: "14px", md: "16px" },
                    fontFamily: "inter, sans-serif",
                    color: "slateGray"
                },
                errorText: {
                    color: "#E53E3E",
                    fontSize: "0.875rem"
                }
            },
            vertical: {
                ...libThemeBase,
                root: {
                    flexDirection: "column",
                    alignItems: "flex-start"
                }
            },
            horizontal: {
                ...libThemeBase,
                root: {
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                label: {
                    flex: "0 0 var(--field-label-width, 80px)"
                }
            }
        }
    },
    defaultVariants: {
        variant: "legacy"
    }
});

export default fieldRecipe;
